var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#C2CFE0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2925 15.4625L13.1725 11.5825L9.2925 7.7025C8.9025 7.3125 8.9025 6.6825 9.2925 6.2925C9.6825 5.9025 10.3125 5.9025 10.7025 6.2925L15.2925 10.8825C15.6825 11.2725 15.6825 11.9025 15.2925 12.2925L10.7025 16.8825C10.3125 17.2725 9.6825 17.2725 9.2925 16.8825C8.9125 16.4925 8.9025 15.8525 9.2925 15.4625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.852d798f.svg";
export { ForwardRef as ReactComponent };